module.exports = __webpack_public_path__ + "img/croco.10306c17.svg";